import clsx from 'clsx';
import styles from './unexpected-client-error.module.scss';

export interface ErrorPageProps {
  className?: string;
}

/**
 * Simple error with minimal dependencies,
 * should be shown only if application cannot be rendered regular way
 * */
export function UnexpectedClientError({className}: ErrorPageProps) {
  return (
    <div className={clsx(styles.error, className)}>
      <div>
        <h1>Sorry, Unexpected Client Error</h1>
        <h2>Please refresh the page. If the error repeats, contact support.</h2>
      </div>
    </div>
  );
}
